export default "__VITE_ASSET__D_xb4QqB__"